import React from 'react';
import Mountain from './Mountain';
import TreeGroup from './trees/TreeGroup';
import Trees from './trees/Trees';
import TreeSolo from './trees/TreeSolo';
import Clouds from './Clouds';

function d2r(degree: number): number {
    return degree * Math.PI/180;
}

export default function Characters() {
    return (
        <>
          <Mountain position={[170, 0, 65]} />

          <Clouds position={[-320, 250, -265]} originalZ={-265} scale={[2, 2, 2]} speed={0.005} rotationX={73} />
          <Clouds position={[-323, 250, -160]} originalZ={-200} scale={[2, 2, 2]} speed={0.005} rotationX={-30} />

          <Clouds position={[-300, 200, 65]} originalZ={65} speed={0.05} rotationX={0} />
          <Clouds position={[-301, 200, 115]} originalZ={115} speed={0.05} rotationX={30} />

          <Clouds position={[-300, 300, 500]} originalZ={500} speed={0.05} rotationX={370} />
          <Clouds position={[-301, 300, 455]} originalZ={455} speed={0.05} rotationX={90} />

          <TreeGroup position={[270, 0, 210]} scale={[2, 2, 2]}  />
          <TreeSolo position={[300, 0, 180]} scale={[2, 2, 2]}  />
          <TreeGroup position={[210, 0, 190]} scale={[2, 2, 2]} rotation={[0, d2r(70), 0]} />
          <TreeGroup position={[100, 0, 195]} scale={[2, 2, 2]} rotation={[0, d2r(160), 0]} />

          <Trees position={[0, 0, -20]} scale={[2, 2, 2]} rotation={[0, d2r(0), 0]} />
          <TreeGroup position={[300, 0, -40]} scale={[2, 2, 2]} rotation={[0, d2r(252), 0]} />
          <TreeGroup position={[190, 0, -50]} scale={[2, 2, 2]} rotation={[0, d2r(140), 0]} />
          <TreeGroup position={[140, 0, -45]} scale={[2, 2, 2]} rotation={[0, d2r(3), 0]} />

          <TreeSolo position={[-40, 0, 100]} scale={[2, 2, 2]}  />
          <TreeGroup position={[-30, 0, 150]} scale={[2, 2, 2]} rotation={[0, d2r(3), 0]} />
          <TreeGroup position={[-50, 0, 20]} scale={[2, 2, 2]} rotation={[0, d2r(180), 0]} />

          <TreeSolo position={[-200, 43, 75]} scale={[2, 2, 2]}  />
          <TreeSolo position={[120, 41, 275]} scale={[2, 2, 2]}  />
          <TreeSolo position={[220, 46, -150]} scale={[2, 2, 2]}  />
          <TreeSolo position={[-10, 18, -120]} scale={[2, 2, 2]}  />

        </>
    );
}